import $ from 'jquery';

$(document).ready(function() {

    // IMAGES
    $('.slider-images').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true,
        centerMode: true,
        centerPadding: '10%',
        mobileFirst: true,
        responsive: [
			{
				breakpoint: 900,
				settings: {
					centerPadding: '50%',
				}
			},
		]
    });
    

    // TIMELINE
    $('.slider-timeline').slick( {
		slidesToShow: 7,
		slidesToScroll: 4,
		arrows: true,
		infinite: false,
		draggable: true,
		responsive: [
			{
				breakpoint: 1180,
				settings: {
					slidesToShow: 4,
					arrows: true,
					slidesToScroll: 4
				}
			},
			
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3,
					arrows: true,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					arrows: true,
					slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '30%',
				}
			}
		]
	});

    // COURSES FEATURED
    $('.slider-courses-featured').slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		draggable: true,
        arrows: false,
        dots: true,
        infinite: false,
        variableWidth: true,
        mobileFirst: true,
        responsive: [
        {
           breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false,
                draggable: false,
            }
        }
     ]
	});


    // COURSES FRONTPAGE
    $('.slider-courses-frontpage').slick( {
		// slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
        dots: true,
		infinite: false,
		draggable: true,
        // centerMode: true,
        // initialSlide: 5,
        // centerPadding: '50px',
        variableWidth: true,
        mobileFirst: true,

        responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: true,
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToScroll: 2,
                    arrows: true,
				}
			},
			{
				breakpoint: 1600,
				settings: {
					slidesToScroll: 3,
                    arrows: true,
				}
			}
		]
	});

    // REVIEWS
    $('.slider-reviews').slick({
        slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
        dots: true,
		infinite: false,
		draggable: true,
        variableWidth: true, // Need this so the slick-track won't be superwide
        mobileFirst: true,
        responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
		            slidesToScroll: 2,
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
		            slidesToScroll: 2,
				}
			}
		]
    });

}); 